module.exports = __webpack_public_path__ + "static/media/slack.7cd94104.png";